(function () {
  function ready(fn) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  function esc(s) {
    return String(s || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function paras(text) {
    return String(text || "")
      .split(/\n{2,}/)
      .map(function (p) {
        return "<p>" + esc(p).replace(/\n/g, "<br>") + "</p>";
      })
      .join("");
  }

    function pageOverride() {
      var out = { handle: "", title: "", html: "", hasHtml: false };
      var el = document.getElementById("ushare-page-override");
      if (el) {
        try {
          var parsed = JSON.parse(el.textContent || "{}");
          out.handle = parsed.handle || "";
          out.title = parsed.title || "";
          out.html = parsed.html || "";
          out.hasHtml = Boolean(parsed.hasHtml);
        } catch (e) {}
      }
      var tpl = document.getElementById("ushare-page-html");
      if (tpl) {
        var html = (tpl.innerHTML || "").trim();
        if (html) {
          out.html = html;
          out.hasHtml = true;
        }
      }
    if (document.querySelector("[data-has-html]")) out.hasHtml = true;
    return out;
  }

  function textOf(node) {
    return String((node && node.textContent) || "").replace(/\s+/g, " ").trim();
  }

  function sectionKind(text) {
    var s = String(text || "").replace(/\s+/g, " ").trim();
    if (/^what\b|^什么是|^qué es|^qu['’]est-ce|^was ist|^что такое|^ما هو|^apa itu/i.test(s)) return "what";
    if (/^how\b|^如何|^怎么做|^cómo se|^comment|^wie wird|^как |^كيف |^bagaimana/i.test(s)) return "how";
    if (/^recovery|^恢复|^recuperación|^récupération|^erholung|^восстановление|^التعافي|^pemulihan/i.test(s)) return "recovery";
    if (/^faqs?$|^frequently asked questions?$|常见问题|preguntas frecuentes|questions fréquentes|häufige fragen|часто задаваемые|الأسئلة الشائعة|pertanyaan umum/i.test(s)) return "faq";
    return "";
  }

  function nodesFromHtml(html) {
    var wrap = document.createElement("div");
    wrap.innerHTML = html || "";
    return Array.prototype.slice.call(wrap.childNodes);
  }

  function parseFaqs(nodes) {
    var faqs = [];
    var q = "";
    var answers = [];
    function flush() {
      if (!q) return;
      faqs.push({ q: q, a: answers.join("\n\n") });
      q = "";
      answers = [];
    }
    nodes.forEach(function (node) {
      if (!node || node.nodeType !== 1) {
        var stray = textOf(node);
        if (q && stray) answers.push(stray);
        return;
      }
      var heading = /^H[1-4]$/.test(node.nodeName);
      if (heading) {
        flush();
        q = textOf(node);
        return;
      }
      var line = textOf(node);
      if (!line) return;
      if (!q) q = line;
      else answers.push(line);
    });
    flush();
    return faqs.filter(function (item) {
      return item.q;
    });
  }

  function parseSteps(nodes) {
    var steps = [];
    nodes.forEach(function (node) {
      if (!node || node.nodeType !== 1) return;
      if (node.nodeName === "UL" || node.nodeName === "OL") {
        Array.prototype.slice.call(node.querySelectorAll("li")).forEach(function (li) {
          var line = textOf(li);
          if (line) steps.push(line);
        });
        return;
      }
      if (node.nodeName === "P") {
        var line = textOf(node);
        if (line) steps.push(line);
      }
    });
    return steps;
  }

  function parsePageSections(html) {
    var source = html || "";
    var headingRe =
      /<(h[1-4]|p)(\s[^>]*)?>\s*(?:<(?:strong|b|span|em)[^>]*>\s*)*(What(?:\s+is[^<]*)?|什么是[^<]*|Qué es[^<]*|Qu['’]est-ce[^<]*|Was ist[^<]*|Что такое[^<]*|ما هو[^<]*|Apa itu[^<]*|How(?:\s+is[^<]*)?|如何[^<]*|怎么做[^<]*|Cómo se[^<]*|Comment[^<]*|Wie wird[^<]*|Как [^<]*|كيف [^<]*|Bagaimana[^<]*|Recovery(?:\s+process)?|恢复[^<]*|Recuperación[^<]*|Récupération[^<]*|Erholung[^<]*|Восстановление[^<]*|التعافي[^<]*|Pemulihan[^<]*|FAQs?|Frequently Asked Questions|常见问题|Preguntas frecuentes|Questions fréquentes|Häufige Fragen|Часто задаваемые вопросы|الأسئلة الشائعة|Pertanyaan umum)(?:\s*<\/(?:strong|b|span|em)>)*\s*<\/\1>/gi;
    var found = [];
    var match;
    while ((match = headingRe.exec(source))) {
      found.push({
        kind: sectionKind(match[3]),
        start: match.index,
        end: match.index + match[0].length
      });
    }
    var buckets = { what: "", how: "", recovery: "", faq: "" };
    var seen = { what: false, how: false, recovery: false, faq: false };
    found.forEach(function (sec, i) {
      if (!sec.kind) return;
      seen[sec.kind] = true;
      var until = i + 1 < found.length ? found[i + 1].start : source.length;
      buckets[sec.kind] += source.slice(sec.end, until);
    });
    if (!seen.what && found.length === 0 && source.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim()) {
      buckets.what = source;
      seen.what = true;
    }
    var recNodes = nodesFromHtml(buckets.recovery);
    var recSteps = parseSteps(recNodes);
    var recText = recNodes
      .filter(function (node) {
        return node.nodeType === 1 && node.nodeName !== "UL" && node.nodeName !== "OL";
      })
      .map(function (node) {
        return textOf(node);
      })
      .filter(Boolean)
      .join("\n\n");
    return {
      whatHtml: buckets.what.trim(),
      hasWhat: seen.what,
      steps: parseSteps(nodesFromHtml(buckets.how)),
      hasHow: seen.how,
      recovery: recText,
      recSteps: recSteps,
      hasRecovery: seen.recovery,
      faqs: parseFaqs(nodesFromHtml(buckets.faq)),
      hasFaq: seen.faq
    };
  }

  function catalogBySlug(s) {
    return (window.USHARE_TREATMENTS || []).filter(function (tx) {
      return tx.s === s;
    })[0];
  }

    function t(key, vars) {
      var s = (window.USHARE_TXD_I18N || {})[key] || "";
      var name = vars && vars.name != null ? vars.name : "";
      var n = vars && vars.n != null ? String(vars.n) : "";
      s = s.split("__N__").join(name || n);
      s = s.split("{{ name }}").join(name);
      s = s.split("{{name}}").join(name);
      s = s.split("{{ n }}").join(n);
      s = s.split("{{n}}").join(n);
      return s;
    }

  ready(function () {
    if (typeof window.ushareApplyI18n === "function") window.ushareApplyI18n();
    var root = document.querySelector("[data-ushare-txd]");
    if (!root) return;
    var slug = root.getAttribute("data-slug") || "";
    var items = window.USHARE_TXD || [];
    var page = pageOverride();
    var listed = catalogBySlug(slug);
    var item = items.filter(function (x) {
      return x.s === slug;
    })[0];
    if (item) {
      if (page.title) item.name = page.title;
      if (page.hasHtml) {
        var parts = parsePageSections(page.html || "");
        if (parts.hasWhat) item.whatHtml = parts.whatHtml;
        if (parts.hasHow) item.steps = parts.steps;
        if (parts.hasRecovery) {
          item.recovery = parts.recovery;
          item.recSteps = parts.recSteps;
        }
        if (parts.hasFaq) item.faqs = parts.faqs;
      }
    } else if (page.title || page.hasHtml || listed) {
      item = {
        s: slug,
        name: page.title || (listed && listed.n) || "",
        whatHtml: "",
        n: listed && listed.i ? listed.i : 0,
        faqs: [],
        steps: [],
        recSteps: [],
      };
      if (page.hasHtml) {
        var fresh = parsePageSections(page.html || "");
        if (fresh.hasWhat) item.whatHtml = fresh.whatHtml;
        if (fresh.hasHow) item.steps = fresh.steps;
        if (fresh.hasRecovery) {
          item.recovery = fresh.recovery;
          item.recSteps = fresh.recSteps;
        }
        if (fresh.hasFaq) item.faqs = fresh.faqs;
      }
    }
    if (item && listed) {
      if (listed.n && !page.title) item.name = listed.n;
      if (listed.i) item.n = listed.i;
      if (listed.wait) item.wait = listed.wait;
      if (listed.cost) item.cost = listed.cost;
      if (listed.stayH) item.stayH = listed.stayH;
      if (listed.stayHotel) item.stayHotel = listed.stayHotel;
      if (listed.stayChina) item.stayChina = listed.stayChina;
      if (listed.inc && listed.inc.length) item.inc = listed.inc;
      if (listed.exc && listed.exc.length) item.exc = listed.exc;
      if (listed.img) item.cardImg = listed.img;
      if (listed.whatImg) item.whatImg = listed.whatImg;
      if (listed.howImg) item.howImg = listed.howImg;
      if (listed.recImg) item.recImg = listed.recImg;
    }
    var mount = root.querySelector("[data-txd-root]");
    if (!item) {
      mount.innerHTML =
        '<div class="ushare-txd-missing"><p>' +
        esc(t("missing")) +
        '</p><p><a href="' +
        (window.ushareUrl || String)("/treatment") +
        '">' +
        esc(t("back")) +
        "</a></p></div>";
      return;
    }

    document.title = item.name + " – Ushare";

    var imgs = (window.USHARE_TXD_IMGS || {})[String(item.n)] || {};
    var card = item.cardImg || (window.USHARE_TXD_CARD || {})[String(item.n)] || "";
    var proc = window.USHARE_TXD_PROC || {};
    var hero = window.USHARE_TXD_HERO || "";
    var check =
      '<svg class="ushare-txd-ico" viewBox="0 0 24 24" fill="none" stroke="#16a34a" stroke-width="2.4"><path d="M5 12.5 9.5 17 19 7"/></svg>';
    var cross =
      '<svg class="ushare-txd-ico" viewBox="0 0 24 24" fill="none" stroke="#dc2626" stroke-width="2.4"><path d="M7 7l10 10M17 7 7 17"/></svg>';
    var chat =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z"/></svg>';

    function listItems(values, icon) {
      return (values || [])
        .map(function (s) {
          return "<li>" + icon + esc(s) + "</li>";
        })
        .join("");
    }

    var wait = item.wait || t("dash");
    var cost = item.cost || t("dash");
    var stayH = item.stayH || t("dash");
    var stayHotel = item.stayHotel || t("dash");
    var stayChina = item.stayChina || t("dash");

    var processHtml = "";
    for (var i = 1; i <= 5; i++) {
      processHtml +=
        '<article class="ushare-txd-pstep">' +
        '<div class="ushare-txd-pstep__pic">' +
        '<img src="' +
        esc(proc[String(i)] || card) +
        '" alt="">' +
        '<span class="ushare-txd-pstep__num">' +
        i +
        "</span></div>" +
        "<h3>" +
        esc(t("process_" + i + "_title")) +
        "</h3><p>" +
        esc(t("process_" + i + "_text")) +
        "</p></article>";
    }

    var quoteBtn =
      '<a class="ushare-txd-quote" href="' +
      (window.ushareUrl || String)("/free-quote?procedure=" + encodeURIComponent(item.name || "")) +
      '">' +
      chat +
      esc(t("quote")) +
      "</a>";

    var whatIll = item.whatImg || imgs.a || card;
    var howIll = item.howImg || imgs.b || card;
    var recIll = item.recImg || imgs.c || card;

    var whatBody = item.whatHtml ? item.whatHtml : item.what ? paras(item.what) : "";
    var whatHtml = whatBody
      ? '<section class="ushare-txd-block"><div class="ushare-txd-wrap">' +
        "<h2>" +
        esc(t("what", { name: item.name })) +
        "</h2>" +
        '<div class="ushare-txd-split"><div class="ushare-txd-copy"><span class="ushare-txd-quote-mark" aria-hidden="true">“</span>' +
        whatBody +
        '</div><div class="ushare-txd-ill">' +
        (whatIll ? '<img src="' + esc(whatIll) + '" alt="">' : "") +
        "</div></div></div></section>"
      : "";

    var howPills = (item.steps || [])
      .map(function (step, idx) {
        return (
          '<div class="ushare-txd-pill"><strong>' +
          esc(t("step", { n: idx + 1 })) +
          "</strong> " +
          esc(step) +
          "</div>"
        );
      })
      .join("");

    var howHtml = howPills
      ? '<section class="ushare-txd-block ushare-txd-how"><div class="ushare-txd-wrap">' +
        "<h2>" +
        esc(t("how", { name: item.name })) +
        "</h2>" +
        '<div class="ushare-txd-split"><div class="ushare-txd-plist">' +
        howPills +
        '</div><div class="ushare-txd-ill">' +
        (howIll ? '<img src="' + esc(howIll) + '" alt="">' : "") +
        "</div></div></div></section>"
      : "";

    var recPills = (item.recSteps || [])
      .map(function (step, idx) {
        return (
          '<div class="ushare-txd-pill"><strong>' +
          esc(t("step", { n: idx + 1 })) +
          "</strong> " +
          esc(step) +
          "</div>"
        );
      })
      .join("");

    var recHtml =
      item.recovery || recPills
        ? '<section class="ushare-txd-block ushare-txd-rec"><div class="ushare-txd-wrap">' +
          "<h2>" +
          esc(t("recovery")) +
          "</h2>" +
          '<div class="ushare-txd-split"><div class="ushare-txd-copy">' +
          paras(item.recovery) +
          (recPills ? '<div class="ushare-txd-plist" style="margin-top:1.6rem">' + recPills + "</div>" : "") +
          '</div><div class="ushare-txd-ill">' +
          (recIll ? '<img src="' + esc(recIll) + '" alt="">' : "") +
          "</div></div></div></section>"
        : "";

    var faqHtml = "";
    if (item.faqs && item.faqs.length) {
      faqHtml =
        '<section class="ushare-txd-faq"><h2>' +
        esc(t("faq")) +
        '</h2><div class="ushare-txd-faq__list">';
      item.faqs.forEach(function (faq) {
        faqHtml +=
          '<div class="ushare-txd-acc"><button type="button">' +
          esc(faq.q) +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m6 9 6 6 6-6"/></svg></button><div class="ushare-txd-acc__body">' +
          paras(faq.a) +
          "</div></div>";
      });
      faqHtml += "</div></section>";
    }

    var incItems = item.inc && item.inc.length ? item.inc : [t("inc_1"), t("inc_2"), t("inc_3"), t("inc_4"), t("inc_5")];
    var excItems = item.exc && item.exc.length ? item.exc : [t("exc_1"), t("exc_2"), t("exc_3"), t("exc_4"), t("exc_5")];

    mount.innerHTML =
      '<section class="ushare-txd-hero"><div class="ushare-txd-hero__media"><img src="' +
      esc(hero) +
      '" alt=""></div><div class="ushare-txd-hero__fade"></div><div class="ushare-txd-hero__inner"><div class="ushare-txd-hero__card"><h1>' +
      esc(t("hero_title", { name: item.name })) +
      '</h1><div class="ushare-txd-hero__stats"><p><span>' +
      esc(t("wait_label")) +
      "</span><strong>" +
      esc(wait) +
      "</strong></p><p><span>" +
      esc(t("cost_label")) +
      "</span><strong>" +
      esc(cost) +
      "</strong></p></div></div></div></section>" +
      '<section class="ushare-txd-facts"><article class="ushare-txd-box"><h2>' +
      esc(t("included")) +
      "</h2><ul>" +
      listItems(incItems, check) +
      '</ul></article><article class="ushare-txd-box"><h2>' +
      esc(t("not_included")) +
      "</h2><ul>" +
      listItems(excItems, cross) +
      '</ul></article><article class="ushare-txd-box"><h2>' +
      esc(t("stay")) +
      '</h2><dl class="ushare-txd-stay"><dt>' +
      esc(t("hospital")) +
      "</dt><dd>" +
      esc(stayH) +
      "</dd><dt>" +
      esc(t("hotel")) +
      "</dt><dd>" +
      esc(stayHotel) +
      "</dd><dt>" +
      esc(t("total_china")) +
      "</dt><dd>" +
      esc(stayChina) +
      "</dd></dl></article></section>" +
      '<section class="ushare-txd-process"><div class="ushare-txd-process__inner"><h2>' +
      esc(t("process_title")) +
      '</h2><p class="ushare-txd-lead">' +
      esc(t("process_lead")) +
      '</p><div class="ushare-txd-steps5">' +
      processHtml +
      "</div>" +
      quoteBtn +
      "</div></section>" +
      whatHtml +
      howHtml +
      recHtml +
      faqHtml;

    mount.addEventListener("click", function (e) {
      var btn = e.target.closest(".ushare-txd-acc button");
      if (!btn) return;
      var acc = btn.parentElement;
      var open = acc.classList.contains("is-open");
      mount.querySelectorAll(".ushare-txd-acc").forEach(function (el) {
        el.classList.remove("is-open");
      });
      if (!open) acc.classList.add("is-open");
    });
  });
})();
